import React, { Component } from 'react';
import swal from "sweetalert2";

import How from './How';
import About from './About';
import Header from './Header';
import Content from './Content';

const email_validator = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim;

export default class LandingPage extends Component {
	constructor(props) {
	  super(props);
	  this.state = {
	    name: "",
	    email: "",
	    errors: {}
	  };
	  this.handleSubmit = this.handleSubmit.bind(this);
	}

	onChange(name, event) {
	  this.setState({ [name]: event.target.value });
	}

	handleSubmit(e) {
	  e.preventDefault();
	  if(this.state.name !== "" && this.state.email !== "" && this.state.email.match(email_validator) !== null) {
	    let data = {};
	    data["fullName"] = this.state.name;
	    data["email"] = this.state.email;

	    fetch("https://test.letsendorse.com/legacy/signup", {
	      method: "POST",
	      headers: {
	        "Content-Type": "application/json"
	      },
	      body: JSON.stringify(data)
	    }).then(res => res.json())
	    .then(data => {
	      swal({
	        type: "success",
	        title: "Congratulations on taking your first step towards building your legacy.",
	        html: 'We will get in touch with you shortly for taking the next steps on your journey to building a legendary trail of impact. <br><br>Meanwhile we invite you to share this initiative with your friends and family because together we can do so much! <br><br><a class="facebook-swal" href="https://www.facebook.com/sharer/sharer.php?u=legacy.letsendorse.com" ><img src="/images/fb.png" style="width:40px; height:40px; margin-right: 20px"></a> <a href="https://twitter.com/home?status=https://legacy.letsendorse.com @LetsEndorse"><img src="/images/twitter.png" style="width:40px; height:40px; margin-right: 20px"></a> <a class="linkedin-swal" href="https://www.linkedin.com/shareArticle?url=legacy.letsendorse.com"><img class="linkedin-swal-img" src="/images/linked-in.png" style="width:35px; height:35; margin-right: 20px"></a> <a class="whatsapp-swal" href="whatsapp://send?text=https://legacy.letsendorse.com"><img src="/images/whatsapp-swal.png" style="width:50px; height:50"></a>',
	        // footer:
	        //   '<a href="https://www.facebook.com/sharer/sharer.php?u=legacy.letsendorse.com" ><img src="Assets/images/fb.png" style="width:40px; height:40px; margin-right: 20px"></a> <a href="https://twitter.com/home?status=https://legacy.letsendorse.com @LetsEndorse"><img src="Assets/images/twitter.png" style="width:40px; height:40px; margin-right: 20px"></a> <a href="https://www.linkedin.com/shareArticle?url=legacy.letsendorse.com" style="display: flex; flex-direction: column; justify-content: center"><img src="Assets/images/linked-in.png" style="width:35px; height:35"></a>',
	        icon: "success",
	        button: "OK"
	      });
	      this.setState({
	        name: "",
	        email: "",
	        errors: {}
	      });
	    }).catch(err => {
	      console.log(err);
	    })
	  } else {
	    swal({
	      type: "warning",
	      title: "Looks like your details are incorrect, kindly re-enter!",
	      button: "OK"
	    });
	    this.setState({
	      name: "",
	      email: ""
	    });
	  }
	}

	render() {
		return (
			<div>
				<Header />
				<Content />
				<How name={this.state.name} email={this.state.email} onChange={this.onChange.bind(this)}
				  handleSubmit={this.handleSubmit.bind(this)} errors={this.state.errors} />
				<About />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Components/LandingPage/LandingPage.js